import React, { createContext, useContext } from "react";
import { useCurrentUser, UseCurrentUserResult } from "../hooks/useCurrentUser";

const CurrentUserContext = createContext<UseCurrentUserResult | null>(null);

export function CurrentUserProvider({ children }: { children: React.ReactNode }) {
  const value = useCurrentUser();
  return <CurrentUserContext.Provider value={value}>{children}</CurrentUserContext.Provider>;
}

export function useCurrentUserContext(): UseCurrentUserResult {
  const ctx = useContext(CurrentUserContext);
  if (!ctx) {
    throw new Error("useCurrentUserContext must be used within CurrentUserProvider");
  }
  return ctx;
}
